import _ from 'lodash';
import { createSelector } from 'reselect';

export const getUserModify = state => _.get(state, 'cvUserModify');

export const getPayload = createSelector(
  [getUserModify],
  userModify => _.get(userModify, 'payload', false),
);

export const getLoading = createSelector(
  [getUserModify],
  userModify => _.get(userModify, 'loading', false),
);

export const getError = createSelector(
  [getUserModify],
  userModify => _.get(userModify, 'error', false),
);

export const getUpdateError = createSelector(
  [getError],
  error => {
    if (error)
      return {
        code: _.get(error, 'code', false),
        message: _.get(error, 'error', false),
      };
    return error;
  },
);

export const getUpdateSuccess = createSelector(
  [getPayload],
  payload => {
    const code = _.get(payload, 'code', false);
    const message = _.get(payload, 'msg', false);
    if (code)
      return {
        code,
        message,
      };
    return false;
  },
);
